export const environment = {
  production: true,
  apiURL: 'https://app.acumen-portal.co.uk/api/',
messagingApiURL: "https://messaging.acumen-portal.co.uk/api/",
  formBuilderApiURL: 'https://app.acumen-portal.co.uk/api/',
  mobileServerAPIURL: 'https://api.acumen-portal.co.uk/api/',
  stitchApiURL: 'https://webhooks.mongodb-stitch.com/api/client/v2.0/app/acumenwaste-paopp/service/',
   chatApiUrl: 'https://api.acumen-portal.co.uk/api/'
};
